export type ColorScheme = 'light' | 'dark'

const DARK: Record<string, string> = {
  '--md-sys-color-surface': '#131316',
  '--md-sys-color-on-surface': '#E5E1E6',
  '--md-sys-color-on-surface-variant': '#C6C5D0',
  '--md-sys-color-surface-container': '#1F1F23',
  '--md-sys-color-surface-container-high': '#2A2A2E',
  '--md-sys-color-secondary-container': '#45464F',
  '--md-sys-color-on-secondary-container': '#E4E2E6',
  '--md-sys-color-outline': '#90909A',
  '--md-sys-color-outline-variant': '#46464F',
  '--md-sys-color-error': '#FFB4AB',
  '--md-sys-color-on-error': '#690005',
  '--md-state-layer': 'rgba(229, 225, 230, 0.08)',
  '--md-swatch-inset': 'rgba(255, 255, 255, 0.18)',
  '--md-scrim': 'rgba(4, 6, 16, 0.72)',
  '--md-elevation-1':
    '0 1px 2px rgba(0, 0, 0, 0.3), 0 1px 3px 1px rgba(0, 0, 0, 0.15)',
  '--md-elevation-2':
    '0 1px 2px rgba(0, 0, 0, 0.3), 0 2px 6px 2px rgba(0, 0, 0, 0.15)',
  'color-scheme': 'dark',
}

const LIGHT: Record<string, string> = {
  '--md-sys-color-surface': '#FFFBFE',
  '--md-sys-color-on-surface': '#1C1B1F',
  '--md-sys-color-on-surface-variant': '#49454F',
  '--md-sys-color-surface-container': '#F3EDF7',
  '--md-sys-color-surface-container-high': '#ECE6F0',
  '--md-sys-color-secondary-container': '#E7E0EC',
  '--md-sys-color-on-secondary-container': '#1D1B20',
  '--md-sys-color-outline': '#79747E',
  '--md-sys-color-outline-variant': '#CAC4D0',
  '--md-sys-color-error': '#B3261E',
  '--md-sys-color-on-error': '#FFFFFF',
  '--md-state-layer': 'rgba(28, 27, 31, 0.08)',
  '--md-swatch-inset': 'rgba(0, 0, 0, 0.18)',
  '--md-scrim': 'rgba(28, 27, 31, 0.45)',
  '--md-elevation-1':
    '0 1px 2px rgba(0, 0, 0, 0.15), 0 1px 3px 1px rgba(0, 0, 0, 0.08)',
  '--md-elevation-2':
    '0 1px 2px rgba(0, 0, 0, 0.18), 0 2px 6px 2px rgba(0, 0, 0, 0.10)',
  'color-scheme': 'light',
}

/**
 * Surface, outline, and elevation tokens for Material light or dark.
 */
export function schemeCssVars(scheme: ColorScheme): Record<string, string> {
  return scheme === 'light' ? { ...LIGHT } : { ...DARK }
}

/**
 * Returns `light` or `dark`, defaulting to dark if the value is unknown.
 */
export function normalizeScheme(value: unknown): ColorScheme {
  return value === 'light' ? 'light' : 'dark'
}
